jQuery(document).ready(function() {

  // Temp fix for redirection when changing page of filtered result, mob version
 
  // Mobile menu next buttons

  jQuery("nav.mobile-menu-open li.menu-item-has-children").prepend("<button class='open-next'><i class='fa fa-angle-right'></i></button>");

  // Toggle mobile sub menus
  jQuery("button.open-next").on("click", function() {
    jQuery(this).closest("li").find(" > ul.sub-menu").slideToggle();
  });

  jQuery("nav.mobile-menu-open li.menu-item-has-children li > a").on("click", function() {
    jQuery(this).closest("li").find(" > ul.sub-menu").slideToggle();
  });

  jQuery("#open-mobile").on("click", function() {
    jQuery("nav.mobile-menu-open").slideToggle();
  });

  jQuery(".open-all").on("click", function() {
    jQuery(".mega-menu-wp").slideToggle();
  });

   jQuery("#show-filter").on("click", function() {
    jQuery(".hide-filters").show();
  });


  jQuery(".minicart").click(function(e){
      e.stopPropagation();
  });

  jQuery(document).click(function(){
      jQuery(".minicart").fadeOut(200);
  });

  jQuery("a#close-minicart").click(function(){
      jQuery(".minicart").fadeOut(200);
  });

  jQuery(document).on("scroll", function() {
    if (jQuery(this).scrollTop() > 200) {
      jQuery("header.main").addClass("scrolled");
    }
  });

  jQuery(document).on("scroll", function() {
    if (jQuery(this).scrollTop() < 200) {
      jQuery("header.main").removeClass("scrolled");
    }
  });

 
});
